import dayjs from 'dayjs';

/**
 * 날짜를 YYYY-MM-DD 형식으로 포맷팅합니다.
 * 
 * @param {string|Date} date - 포맷팅할 날짜
 * @returns {string} 포맷팅된 날짜 문자열 또는 빈 문자열
 */
export const formatDate = (date) => {
  if (!date) return '';
  return dayjs(date).format('YYYY-MM-DD');
};

/**
 * 시작일과 종료일의 유효성을 검사합니다.
 * 종료일이 시작일보다 이전이면 false를 반환합니다.
 * 
 * @param {string} startDate - 시작일 (YYYY-MM-DD 형식)
 * @param {string} dueDate - 종료일 (YYYY-MM-DD 형식)
 * @returns {boolean} 유효성 검사 결과
 */
export const validateDateRange = (startDate, dueDate) => {
  if (!startDate || !dueDate) return true;
  const start = dayjs(startDate);
  const due = dayjs(dueDate);
  return !due.isBefore(start);
};
